'use client';

import dynamic from 'next/dynamic';

import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useAccountInfo } from '@/hooks/query/account';

const DeepInterviewContainer = dynamic(() => import('../deep-interview-container').then(m => m.DeepInterviewContainer));

export function DeepInterviewManager() {
	const { SiteConfigsData } = useGetSiteConfigs();
	const { user } = useAccountInfo();

	const canSeeContainer = SiteConfigsData?.EnableCustomerDeppConversation && 
		user?.IsCustomerDeepConversation;
	
	return canSeeContainer ? (
		<DeepInterviewContainer />
	) : null;
};